export default () => ({
  min: 0,
  max: 35000000,
  formatValue(value) {
    const val =
      value === 'min'
        ? Math.min(this.min, this.max)
        : Math.max(this.min, this.max);
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  },

  storeFilter() {
    const values1 =
      Math.min(this.min, this.max) == this.$el.min
        ? null
        : {
          text: this.formatValue('min'),
          value: Math.min(this.min, this.max),
        };
    let filter1 = {
      filter: 'property_price:gte',
      values: values1 ? [JSON.stringify(values1)] : '',
    };

    const values2 =
      Math.max(this.min, this.max) == this.$el.max
        ? null
        : {
          text: this.formatValue('max'),
          value: Math.max(this.min, this.max),
        };
    let filter2 = {
      filter: 'property_price:lte',
      values: values2 ? [JSON.stringify(values2)] : '',
    };
    this.$store.filter.set(filter1);
    this.$store.filter.set(filter2);
  },

  init() {},
});
